// eslint-disable-next-line import/extensions
import { doBackendRequest } from '~/assets/js/utils/auth-utils.js';

const sendUserDataToUserlane = () => {
    try {
        /*
        Userlane is defined in template.html and payment-template.html
        which is used only for certain necessary pages.
        This means, not every page has reference for Userlane.
        */

        // eslint-disable-next-line no-undef
        const userlane = Userlane;

        doBackendRequest(
            'GET',
            '/api/user_details_for_userlane',
            (response) => {
                // eslint-disable-next-line camelcase
                const { on_free_trial, login_count } = response;
                const customerUserId = response.email;
                const subscribedUntil = new Date(response.subscribed_until * 1000);
                const payload = {
                    subscribedUntil,
                    onFreeTrial: on_free_trial,
                    loginCount: login_count,
                };

                userlane('identify', customerUserId, payload);
                userlane('init', 'q2m12');
            },
            undefined,
            undefined,
        );
    } catch (error) {
        /*
        Userlane does not exist in current page.
        No need to send any data.
        */
    }
};

export default sendUserDataToUserlane;
